import React from 'react'
import Icon from 'react-icon-base'

export default props => {
  return (
    <Icon viewBox="2 3 19 19" {...props}>
      <title>{props.title || 'Fullscreen'}</title>
      <g>
        <path d="M8.979 4a1 1 0 0 1-1 1H4v4a1 1 0 1 1-2 0V4a1 1 0 0 1 1-1h4.979a1 1 0 0 1 1 1zM20 3h-4.979a1 1 0 1 0 0 2H19v4a1 1 0 1 0 2 0V4a1 1 0 0 0-1-1zM7.979 20H4v-4a1 1 0 1 0-2 0v5a1 1 0 0 0 1 1h4.979a1 1 0 1 0 0-2zM20 15a1 1 0 0 0-1 1v4h-3.979a1 1 0 1 0 0 2H20a1 1 0 0 0 1-1v-5a1 1 0 0 0-1-1z" />
      </g>
    </Icon>
  )
}
